import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShieldCheck2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"shield-check-2, protect, security, check"} maskId="square-filled-radius-0-stroke-1-IconShieldCheck2"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V18.301L12 23.0657L3 18.301V3ZM15.2071 10.25L14.5 9.54289L11 13.0429L9.5 11.5429L8.79289 12.25L11 14.4571L15.2071 10.25Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconShieldCheck2;
